module.exports = __webpack_public_path__ + "img/shop7-2.115e2274.png";